(function ($) {
	$(function () {
		$('.ld_members-search-container').each(function () {
			var $module = $(this);

			var $container = $module.find('.search-container');
			var json = $container.attr('data-members');

			$container.removeAttr('data-members');

			var data = JSON.parse(json);
			var members = data.members;

			$module.on('keyup ', '#members-search', function (e) {
				$module.trigger('tl.membersSearch.run');
			});

			$module.on('tl.membersSearch.run ', function (e) {
				var value = $module.find('input').val().trim().toLowerCase();

				if (value.length <= 0) {
					$module
						.removeClass('open')
						.find('ul').empty();
					return;
				}

				$module.addClass('open');

				var html = "";
				$.each(members, function (i, member) {
					var fullnameMatch = member.FullName && member.FullName.indexOf(value) >= 0;
					var companyMatch = member.CompanyLower && member.CompanyLower.indexOf(value) >= 0;
					var usernameMatch = member.Username && member.Username.indexOf(value) >= 0;

					if (fullnameMatch || companyMatch || usernameMatch) {
						html += "<li data-username='" + member.Username + "' data-userslug='" + member.Slug + "'>" + member.Company + "</li>";
					}
				});

				if (!html) {
					html = "<li>No results</li>";
				}

				$module.find('ul').html(html);
			});

			$module.on('click', '.et_close_search_field', function () {
				$module.find('input').val('');
				$module.trigger('tl.membersSearch.run');
			});

			$module.on('click', 'ul li', function () {
				var userslug = $(this).attr('data-userslug');

				if (!userslug) {
					return;
				}

				window.location.href = window.ld.homeUrl + "/members/" + $(this).attr('data-userslug');
			});
		});
	});
})(jQuery);
